import { render, staticRenderFns } from "./AssetTable.vue?vue&type=template&id=80da98e6&scoped=true&"
import script from "./AssetTable.vue?vue&type=script&lang=js&"
export * from "./AssetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80da98e6",
  null
  
)

export default component.exports